
import React, { useState } from "react";
import { useLocation, NavLink } from "react-router-dom";

import { Nav, Collapse } from "react-bootstrap";
import Colors from "utils/Colors";
import nav_ from "nav_";
import "./Sidebar.css";
import { useDispatch } from 'react-redux';
import { logout } from "../../redux/AuthSlice";

function Sidebar({ color, image, isOpen = true, className = '', onClose }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [openDropdowns, setOpenDropdowns] = useState({});

  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const toggleDropdown = (key) => {
    setOpenDropdowns(prev => {
      const newState = {};
      newState[key] = !prev[key];
      return newState;
    });
  };

  return (
    <div className={`sidebar ${!isOpen ? 'sidebar-hidden' : ''} ${className}`} data-color={color} style={{ backgroundColor: Colors.primary }}>
      <div
        className="sidebar-background"
        style={{
          backgroundColor: Colors.primary
        }}
      />
      
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center" style={{
            // border:"1px solid red",
            width:"100%",
            justifyContent:"center",
            borderRadius:"10px",
            padding:"10px",
            // backgroundColor:"white"
          }}>

            <div className="logo-img">
             
              <img src="https://backend.vendispot.wise-hustlers.com/uploads/logo.png"
              style={{  height: '50px', }}
              />
            </div>

         
          </div>
          <div className="sidebar-close-btn d-lg-none" onClick={onClose}>
            <i className="fas fa-times"></i>
          </div>
        </div>
        <Nav>
          {nav_.map((prop, key) => {
            if (!prop.redirect) {
              if (prop.dropdown) {
                return (
                  <React.Fragment key={key}>
                    <li className={activeRoute(prop.layout + prop.path)}>
                      <div
                        className="nav-link"
                        onClick={() => toggleDropdown(key)}
                        style={{ cursor: 'pointer' }}
                      >
                        {typeof prop.icon === 'string' ? <i className={prop.icon} /> : prop.icon}
                        <p>{prop.name} <i className={`fas fa-chevron-${openDropdowns[key] ? 'up' : 'down'} ml-auto`}></i></p>
                      </div>
                    </li>
                    <Collapse in={openDropdowns[key]}>
                      <div>
                        {prop.dropdown.map((dropdownItem, dropdownKey) => (
                          <li key={dropdownKey} className={`dropdown-item-li ${activeRoute(dropdownItem.layout + dropdownItem.path)}`}>
                            <NavLink
                              to={dropdownItem.layout + dropdownItem.path}
                              className={({ isActive }) => ` ${isActive ? 'active' : ''}`}
                            >
                              {typeof dropdownItem.icon === 'string' ? <i className={dropdownItem.icon} /> : dropdownItem.icon}
                              <p>{dropdownItem.name}</p>
                            </NavLink>
                          </li>
                        ))}
                      </div>
                    </Collapse>
                  </React.Fragment>
                );
              } else {
                return (
                  <li
                    className={activeRoute(prop.layout + prop.path)}
                    key={key}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                    >
                      {typeof prop.icon === 'string' ? <i className={prop.icon} /> : prop.icon}
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              }
            }
            return null;
          })}

          {/* Mobile Logout Button */}
          <li className="mobile-logout d-lg-none">
            <div className="nav-link" onClick={() => {
              const Swal = require('sweetalert2');
              Swal.fire({
                title: 'Are you sure?',
                text: 'You will be logged out of your account ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#001529',
                confirmButtonText: 'Yes, logout!',
                cancelButtonText: 'Cancel'
              }).then((result) => {
                if (result.isConfirmed) {
                 dispatch(logout())
                }
              });
            }}>
              <i className="fas fa-sign-out-alt"></i>
              <p>Logout</p>
            </div>
          </li>
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
